<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vi"></a><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc-fm"><a class="nounder" href="#/xhtml/acknowledgments#acknowledgments"> <em>Acknowledgments</em></a></p>
<p class="toc-fm"><a class="nounder" href="#/xhtml/intro#intro">Introduction: The Contested Terms of Manhood</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch01">1 “A Good Moral Regiment”: Conduct Unbecoming a Gentleman</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 “The Model of the Gentleman”: Gentility and Self-Control</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 “A Regular Old-Fashioned Free Fight”: Physical Prowess and Honor</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 “If You Will Go with Me outside the Lines”: Dueling and the Degenerate Affair of Honor</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 “The Thick-Fingered Clowns”: Social Status and Discipline</span></p>
<p class="toc-chap"><a id="page_viii"></a><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 “The Shoulder-Strap Gentry”: Officers, Privates, and Equal Manhood</span></p>
<p class="toc-bm1"><span class="nounder" href="#/xhtml/conclusion#conclusion" title="Link target outside of Sample">Conclusion: The War for Manhood</span></p>
<p class="toc-bm1"><span class="nounder" href="#/xhtml/appendix#appendix" title="Link target outside of Sample"><em>Appendix: Note on Method and Sources</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/bibliography#bibliography" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/author#author" title="Link target outside of Sample"><em>About the Author</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3d913a29